import { resources } from '../../utils/resources';
import './WalletItem.css';

const WalletItem = (props) => {
    return (
        <div className='walletItem' onClick={props.onClick}>
            <div className="walletItem__wallet">
                <div className={`walletItem__radioBtn ${props.active ? 'active' : 'unactive'}`}>
                    <img src={resources.icons.radiobutton} alt="" />
                </div>
                <div className="walletItem__walletValue appearanceAnimation">
                    {props.value}
                </div>
            </div>
            <button style={{backgroundImage: `url(${resources.icons.bin})`}} className="walletItem__btnDel" onClick={(e) => {
                e.stopPropagation(); // Предотвращаем срабатывание onClick на родителе
                props.onDelete();
            }}></button>
        </div>
    );
};

export default WalletItem;